'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _FAQ = require('./FAQ.css');

var _FAQ2 = _interopRequireDefault(_FAQ);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAQ = (_dec = (0, _reactCssModules2.default)(_FAQ2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FAQ, _Component);

  function FAQ(props) {
    (0, _classCallCheck3.default)(this, FAQ);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FAQ.__proto__ || (0, _getPrototypeOf2.default)(FAQ)).call(this, props));

    _this.renderTop = function () {
      return _react2.default.createElement(
        _components.Link,
        {
          to: '#top',
          title: 'Back to top'
        },
        _react2.default.createElement(
          'div',
          { styleName: 'link-to-top' },
          'Back to top',
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-up' })
        )
      );
    };

    _this.renderQuestions = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'questions' },
        _react2.default.createElement(
          _components.Link,
          { to: '#1', title: 'What is Tobacco Free Funds?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '1. What is Tobacco Free Funds?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          { to: '#2', title: 'Why entertainment companies?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '2. What do entertainment companies have to do with tobacco?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          { to: '#3', title: 'How do entertainment companies compare?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '3. How do entertainment companies compare?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          { to: '#4', title: 'Where does the tobacco grade come from?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '4. Where does the \u201CTobacco Grade\u201D come from?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          { to: '#5', title: 'What are socially responsible funds?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '5. What are socially responsible funds? What about funds that engage the companies they own to push for better behavior?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          {
            to: '#6',
            title: 'What companies do you look for when funds are screened?'
          },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '6. What companies do you look for when funds are screened?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          { to: '#7', title: 'Why do you emphasize 401(k)?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '7. Why do you emphasize 401(k)\u2019s? Does the tool work for other types of investment vehicles?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          { to: '#8', title: 'Who is As You Sow?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '8. Who is As You Sow?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          { to: '#9', title: 'Where do you get your data?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '9. Where do you get your data?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          { to: '#10', title: 'Where can I learn more about this?' },
          _react2.default.createElement(
            'div',
            { styleName: 'question' },
            '10. Where can I learn more about this?',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'another-question' },
          _react2.default.createElement(
            'span',
            null,
            'Have another question? '
          ),
          _react2.default.createElement(
            _components.Link,
            {
              xstrong: true,
              styleName: 'contact',
              to: _config2.default.links.contact,
              title: 'Contact us'
            },
            'Contact us',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        )
      );
    };

    _this.renderAnswers = function () {
      // IMAGES
      var sriIcon = require('../../../static/images/sri.png');
      var ussifLogo = require('../../../static/images/ussif-logo.png');

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'answers' },
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '1' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '1. What is Tobacco Free Funds?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Tobacco Free Funds'
              ),
              ' is a search platform that enables you to find out if your savings are being used to fund companies that produce tobacco products or promote tobacco to kids. We also help you find investment options that support a cleaner and healthier future.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Tobacco is the #1 cause of preventable death in the U.S., causing ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.cdc.gov/mmwr/preview/mmwrhtml/mm5745a3.htm',
                  xstrong: true
                },
                'half a million deaths a year in the U.S. alone.'
              ),
              ' ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'http://publications.iarc.fr/Non-Series-Publications/' + 'World-Cancer-Reports/World-Cancer-Report-2014',
                  xstrong: true
                },
                'Tobacco use is increasing globally,'
              ),
              ' particularly in the developing world. ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'http://apps.who.int/iris/bitstream/10665/43818/1/' + '9789241596282_eng.pdf',
                  xstrong: true
                },
                'One billion lives are at stake in the battle against tobacco addiction this century.'
              ),
              ' ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.reader,
                  strong: true,
                  title: 'Download Acrobat Reader to view this PDF'
                },
                _react2.default.createElement('i', { className: 'fa fa-file-pdf-o' }),
                _react2.default.createElement(
                  _components.SrOnly,
                  null,
                  'Download Acrobat Reader to view this PDF'
                )
              ),
              ' The World Health Organization describes tobacco as the most devastating, but preventable, epidemic of our time.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                {
                  xstrong: true,
                  to: _config2.default.routes.clean,
                  title: 'Top Scoring Funds | Tobacco Free Funds'
                },
                'Click to here to see a list of funds that avoid tobacco investments.'
              )
            ),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '2' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '2. What do entertainment companies have to do with tobacco?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'There is scientific consensus that exposure to tobacco in movies causes kid to begin smoking. Learn about the history, research, and company analysis below.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-subtitle' },
              'The History'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The U.S. and other countries have long tried to halt tobacco promotion to children and adolescents. In 1971, ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.cdc.gov/tobacco/data_statistics/by_topic/' + 'policy/legislation/',
                  xstrong: true
                },
                'Congress banned tobacco commercials on radio and television.'
              ),
              ' In the 1980s and 1990s, restrictions were negotiated on tobacco advertising in print media and on billboards. Yet depictions of smoking continue in movies and on television. ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.surgeongeneral.gov/library/reports/' + 'preventing-youth-tobacco-use/',
                  xstrong: true
                },
                'The scientific consensus is that tobacco imagery causes kids to begin smoking.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'The history of collaboration between the film and tobacco industries is well-documented, including by ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.cdc.gov/tobacco/data_statistics/sgr/2012/',
                  xstrong: true
                },
                'the U.S. Surgeon General'
              ),
              '. From the late 1920s to at least the mid-1990s, tobacco companies paid millions of dollars to place their products in entertainment media accessible to kids. These cross-promotion and product placement deals were in addition to the millions in advertising dollars that tobacco companies paid to the major studios\' television production arms and to broadcast networks.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The historic 1998 legal settlement with state Attorneys General (the ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'http://www.publichealthlawcenter.org/topics/' + 'tobacco-control/tobacco-control-litigation/' + 'master-settlement-agreement',
                  xstrong: true
                },
                '\u201CMaster Settlement Agreement\u201D'
              ),
              ') barred tobacco companies from paying to place their brands in U.S. movies and TV shows accessible to children and adolescents. Over the past decade, 180 nations and other territories have become parties to the ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'http://www.who.int/fctc/',
                  xstrong: true
                },
                'World Health Organization Framework Convention on Tobacco Control'
              ),
              ' (FCTC) Article 13, which commits countries to eliminating tobacco promotion on all media platforms, including film. The United States signed but did not ratify this treaty. No U.S. law or regulation currently bars tobacco product placement in media accessible to children and adolescents. And the Master Settlement Agreement with U.S. tobacco firms does not prevent any film or television producer or distributor in the U.S. from making a promotional deal with a multinational tobacco company or its agents.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-subtitle' },
              'The Research'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In 2012, the U.S. Surgeon General reviewed extensive scientific literature and concluded that ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.surgeongeneral.gov/library/reports/' + 'preventing-youth-tobacco-use/',
                  xstrong: true
                },
                'exposure to smoking on screen causes kids to smoke'
              ),
              '. This seminal report concluded that an R-rating for future movies with smoking would lower teen smoking rates by 18 percent and ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://smokefreemovies.ucsf.edu/research/' + 'key-reports/cdc-fact-sheets',
                  xstrong: true
                },
                'prevent one million tobacco deaths among kids alive today'
              ),
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In July 2017, ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.cdc.gov/mmwr/volumes/66/wr/' + 'mm6626a1.htm?s_cid=mm6626a1_w',
                  xstrong: true
                },
                'CDC\u2019s Morbidity and Mortality Weekly Report (MMWR)'
              ),
              ' noted that \u201Cthe steady decline in the number of tobacco incidents in youth-rated movies from 2005\u20132010 stopped after 2010\u201D and re-affirmed the necessity for R-rating movies with smoking. The CDC report, covered in ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.nytimes.com/2017/07/17/well/family/' + 'why-smoking-in-films-harms-children.html',
                  xstrong: true
                },
                'The New York Times'
              ),
              ', credited investors with helping to reduce tobacco imagery in kid-rated movies.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'However, the Motion Picture Association of America, the trade group for the major studios that governs the U.S. movie rating system, has repeatedly refused to adopt the R-rating for smoking.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In August 2017, 17 leading U.S. health organizations (including American Cancer Society and medical organizations representing more than 630,000 doctors) ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://www.aap.org/en-us/about-the-aap/' + 'aap-press-room/Pages/Leading-Health-Groups-Demand-' + 'Film-Industry-Give-R-Rating-to-Movies-That-Depict-' + 'Smoking.aspx',
                  xstrong: true
                },
                'demanded that movie producers, distributors and exhibitors apply an R rating to all films that include depictions of smoking or tobacco'
              ),
              '.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-subtitle' },
              'The definition of a \u201CTobacco Free\u201D entertainment company'
            ),
            _react2.default.createElement(
              'ol',
              { type: 'a' },
              _react2.default.createElement(
                'li',
                null,
                'Stipulates in its distribution and licensing agreements that exhibition of any video content with tobacco imagery will be preceded by a strong anti-tobacco spot announcement, in all media and in all distribution territories;'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Requires each credited producer of a video content with tobacco imagery to file affidavits stating that nobody associated with the video content production entered into any agreement in regard to the representation of tobacco in the video content;'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Stipulates in all production agreements that the finished video content shall not include any tobacco product brand or facsimile;'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Stipulates in all production agreements that there should be no tobacco imagery in any video content conceived to be youth-rated, with the possible exception of video content that depicts tobacco use only by an actual historical person (as in a documentary or a biographical drama) or accurately portrays the serious health consequences of tobacco use.'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Further, that the company (if it is an MPAA member), in its role on the governing board of the Motion Picture Association of America, explicitly supports updating the rating and advertising standards and guidelines to assign an R-rating to any video content with tobacco imagery, with the possible exceptions stated at (d).'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-subtitle' },
              'Who is responsible?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Tobacco Free Funds identifies five equities that own major (MPAA-member) video production studios:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'Comcast (Universal, Focus)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Disney (Disney, 21st Century Fox, Marvel, Lucasfilm, Pixar, Touchstone)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Sony (Sony Pictures, Columbia, Screen Gems)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'AT&T (Time Warner, Warner Bros., New Line)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'ViacomCBS (Paramount)'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Tobacco Free Funds also identifies one equity that owns a large non-MPAA member studio:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'Lions Gate Entertainment (Lionsgate)'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Additionally, four equities have been identified that produce original video content that is shared through online streaming services. These companies have not been included in the current Tobacco Free Funds entertainment companies screen, meaning they don\'t affect a mutual fund\'s Tobacco Free Funds grade, because insufficient data has been processed about the companies\' tobacco exposure. However, they will be monitored for possible future inclusion.'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'Netflix (Netflix Originals)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Amazon (Amazon Studios)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Apple (Apple TV+)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Google (Youtube TV)'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Tobacco Free Funds screens could be extended to other industries if scientific research finds that these companies are responsible for recruiting new smokers. When data collection is in place, Tobacco Free Funds may include:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'Cable and satellite companies such as Charter and Dish without appropriate notifications and safeguards at product selection or point-of-purchase.'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Video streaming services which lack appropriate notifications and safeguards at product selection or point-of-purchase for third-party entertainment products with tobacco imagery.'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Film exhibitors and video retailers such as Cinemark, Regal, Best Buy, Redbox, and Target without appropriate notifications and safeguards at point-of-purchase of entertainment products with tobacco imagery.'
              )
            ),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '3' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '3. How do entertainment companies compare?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'None of the major movie studios are \u201CTobacco Free\u201D.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Six publicly-traded parent companies own major movie studios:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'Comcast (Universal, Focus)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Disney (Disney, 21st Century Fox, Lucasfilm, Marvel, Pixar, Touchstone)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Lions Gate Entertainment (Lionsgate)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Sony (Sony, Columbia, Screen Gems)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'AT&T (Time Warner, Warner Bros., New Line)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'ViacomCBS (Paramount, CBS Films)'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'By 2013, all major movie studios or their parent companies had adopted tobacco depiction policies that may discourage but do not eliminate smoking in their youth-rated movies (see chart below). Sizeable loopholes in these policies, such as allowing smoking for \u201Ccreative\u201D reasons, have prevented smoking incidents in PG-13 films industry-wide from falling since 2010. In 2016, more than one in three PG-13 movies from MPAA-member studios still featured smoking.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Among the major studios, Sony and ViacomCBS ranks as the smokiest with 50 percent of youth-rated movies featuring smoking from the year they adopted their first policy until 2019. All other studios (Comcast, Disney, AT&T) had between 41-44% of movies with tobacco use.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-subtitle' },
              'Comparison of studios by smoking policy from the year they adopted their first policy through 2019'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                {
                  to: 'https://smokefreemovies.ucsf.edu/whos-accountable/' + 'company-policies',
                  xstrong: true,
                  title: 'Adapted from Smokefree Movies, University of ' + 'California, San Francisco'
                },
                _react2.default.createElement(
                  'em',
                  null,
                  'Adapted from Smokefree Movies, University of California, San Francisco'
                )
              )
            ),
            _react2.default.createElement(
              'table',
              { styleName: 'company-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Company'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Policy date'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Subjective exceptions'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Youth-rated films w/ smoking'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/company/comcast',
                        xstrong: true,
                        title: 'Comcast (Universal) | UCSF Smoke Free Movies'
                      },
                      'Comcast (Universal)'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/sites/' + 'smokefreemovies.ucsf.edu/files/' + 'Comcast policy 2007 v080420.docx',
                        xstrong: true,
                        title: 'Comcast 2007 | UCSF Smoke Free Movies'
                      },
                      '2007'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '"importance [from a] factual or creative standpoint...difficulty in removing it"'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '41%'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/company/disney',
                        xstrong: true,
                        title: 'Disney | UCSF Smoke Free Movies'
                      },
                      'Disney'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '2007, ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'http://smokefreemovies.ucsf.edu/sites/' + 'smokefreemovies.ucsf.edu/files/' + 'Disney policy 2012.docx',
                        xstrong: true,
                        title: 'Disney 2012 | UCSF Smoke Free Movies'
                      },
                      '2012'
                    ),
                    ', ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/sites/' + 'smokefreemovies.ucsf.edu/files/' + 'Disney policy v080420.docx',
                        xstrong: true,
                        title: 'Disney 2015 | UCSF Smoke Free Movies'
                      },
                      '2015'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Portrayals of "smoking in an unfavorable light or [that] emphasize the negative consequences"'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '44%'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/company/sony',
                        xstrong: true,
                        title: 'Sony | UCSF Smoke Free Movies'
                      },
                      'Sony'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/sites/' + 'smokefreemovies.ucsf.edu/files/' + 'Sony policy 2012 v080420.docx',
                        xstrong: true,
                        title: 'Sony 2012 | UCSF Smoke Free Movies'
                      },
                      '2012'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '"important tie to the creative context of the project or the creative vision of the filmmaker"'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '50%'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/company/time-warner',
                        xstrong: true,
                        title: 'AT&T (Time Warner) | UCSF Smoke Free Movies'
                      },
                      'AT&T (Time Warner)'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '2005, 2007, ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/sites/' + 'smokefreemovies.ucsf.edu/files/' + 'ATT policy v080420_0.docxf',
                        xstrong: true,
                        title: 'AT&T (Time Warner) 2018 | UCSF Smoke Free Movies'
                      },
                      '2018'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '"compelling creative reason"'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '42%'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/company/viacom',
                        xstrong: true,
                        title: 'ViacomCBS (Paramount) | UCSF Smoke Free Movies'
                      },
                      'ViacomCBS (Paramount)'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://smokefreemovies.ucsf.edu/sites/' + 'smokefreemovies.ucsf.edu/files/Viacom policy 2013 v080420.docx',
                        xstrong: true,
                        title: 'Viacom 2013 | UCSF Smoke Free Movies'
                      },
                      '2013'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '"creative vision...filmmaker believes that the depiction of smoking or tobacco is important to the film"'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '50%'
                  )
                )
              )
            ),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '4' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '4. Where does the "Tobacco Grade" come from?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'Tobacco Free Funds scans mutual fund holdings for two types of companies: ',
              _react2.default.createElement(
                'strong',
                null,
                'tobacco companies'
              ),
              ', and ',
              _react2.default.createElement(
                'strong',
                null,
                'tobacco-promoting entertainment companies'
              ),
              '. If any companies on our screen lists are found in a mutual fund\'s portfolio, we calculate the overall exposure. ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '#6', title: 'FAQ: What companies do you look for when funds are screened?' },
                'See below the lists of the specific companies we screen for.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Based on whether or not a fund has investment in tobacco companies and/or tobacco-promoting entertainment companies, we assign a letter grade.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 1, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'No holdings flagged for our tobacco screens. Assigned a grade of A.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 2, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'Fund is invested in tobacco-promoting entertainment companies, but no holdings flagged for our tobacco producer screen. Assigned a grade of B.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 3, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'Fund is invested in tobacco producers, below the threshold of 0.5%. Assigned a grade of C.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 4, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'Fund is invested in tobacco producers, above the threshold of 0.5% and below 1.2%. Assigned a grade of D.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 5, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'Fund is invested in tobacco producers, above the threshold of 1.2%. Assigned a grade of F.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'These thresholds reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in the C, D, and F grade ranges.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If a fund owns some of the companies we screen for, but has a proven track record of engaging the companies it owns by taking actions such as ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://go.asyousow.org/take-action-tobacco-free-funds', title: 'Read the investor letter signed by firms managing over $64 billion in assets' },
                'signing our Investor Statement on Tobacco Depictions in Movies,'
              ),
              ' it earns a special acknowledgement as a \u201Cknown sustainability engager\u201D, instead of a letter grade.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 1.5, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                '\u201CKnown sustainability engager\u201D grade. Fund is offered by an asset manager that frequently engages companies it invests in to push for better behavior using the shareholder resolution process.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.faq + '#5', title: 'More about how fund managers engage companies on tobacco in youth entertainment' },
                ' Read more about how fund managers engage companies on tobacco in youth entertainment.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.works },
                'For more on our screening methodology, visit our How it Works page.'
              )
            ),
            _react2.default.createElement('br', null),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '5' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '5. What are socially responsible funds? What about funds that engage the companies they own to push for better behavior?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement('img', { styleName: 'sri', src: sriIcon, alt: 'Socially responsible fund icon' }),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Socially responsible funds'
              ),
              ' make investment decisions based on issues like environmental responsibility, human rights, or religious views. A socially responsible fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are socially responsible.'
            ),
            _react2.default.createElement('img', { styleName: 'ussif', src: ussifLogo, alt: 'US-SIF - The Forum for Sustainable and Responsible Investment icon' }),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'US-SIF - ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.ussif, title: 'US-SIF - The Forum for Sustainable and Responsible Investment' },
                  'The Forum for Sustainable and Responsible Investment'
                )
              ),
              ' is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of tobacco products, or in the manufacturing of products necessary for production of tobacco products. Look for this symbol to find funds that are members of US-SIF.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'engagement-icon-flexcontainer' },
              _react2.default.createElement(_components.Grade, { grade: 1.5, large: true }),
              _react2.default.createElement(
                'span',
                { styleName: 'engagement-icon-headline' },
                'engagement'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Some socially responsible funds go further, actively engaging the companies they own to promote sustainability and long-term value. Indeed, efforts by socially responsible investors whose funds are found on this site have been crucial to driving positive change at movie studios. Shareholder pressure helped drive Disney to pledge to remove smoking from all films that it produces rated PG-13 or lower.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'A number of fund families have taken actions such as signing investor letters, or filing ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.aysvoteshares, title: 'As You Sow: Vote your shares' },
                'shareholder resolutions'
              ),
              ' asking for social and environmental policy changes at the companies they invest in. These fund managers deserve special acknowledgement - often, they\u2019re using their investments to make sure they have a voice at the table to call for real improvements in company behavior.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We identified fund families that have ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.speakout, title: 'Take action: Tell Hollywood to take smoking out of kid rated movies!' },
                'signed investor letters'
              ),
              ', filed shareholder resolutions, or otherwise shown a commitment to engaging the entertainment companies they own on tobacco issues. If a fund is invested in entertainment companies, but the fund family is a known engager, it earns a special score. Look for the engagement symbol to find funds from asset managers that engage entertainment companies on tobacco issues.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Are you a fund manager that has filed a social or environment-related shareholder resolution, or otherwise engage the companies you own on tobacco public health issues?'
              ),
              ' ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, styleName: 'contact', to: '#contact', title: 'Contact us' },
                'Get in touch - we\u2019d love to hear from you.'
              )
            ),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '6' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '6. What companies do you look for when funds are screened?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'Two screens are applied to each fund \u2013 a list of tobacco producers and manufacturers of tobacco products, and a list of entertainment companies that promote tobacco to kids by failing to properly rate their films.'
            ),
            _react2.default.createElement(_components.ScreenedCompanies, null),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '7' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '7. Why do you emphasize 401(k)\u2019s? Does the tool work for other types of investment vehicles?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'For many of us, the majority of our investments are in 401(k) plans offered by our employers. 401(k)s invest mostly through mutual funds and exchange-traded funds (ETFs). But those funds can invest in a wide array of securities, and it\u2019s not always easy for investors to investigate what\u2019s inside the funds they own. You can spend hours poring over mutual fund prospectuses, and still not fully grasp everything your 401(k) is invested in. Your retirement money may be invested in economically and morally risky tobacco companies.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'But regardless of how your money is invested \u2014 whether through a 401(k), a traditional or Roth IRA, a pension fund or other vehicle \u2014 if you hold mutual funds, we can help you analyze them for tobacco holdings.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You can request that your employer include Tobacco Free options in your 401(k) plan \u2014 ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.toolkit, title: '401k toolkit' },
                'learn how.'
              )
            ),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '8' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '8. Who is As You Sow?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.ays, title: 'As You Sow' },
                'As You Sow'
              ),
              ' promotes environmental and social corporate responsibility through shareholder advocacy, coalition building, innovative legal strategies, and online financial transparency tools. We are the nation\u2019s leading non-profit organization practicing direct shareholder engagement on environmental, social, and governance issues. Founded in 1992, As You Sow believes that corporations must be willing participants in solutions to most of today\u2019s pressing issues; and we believe that shareholders are the single most powerful force for motivating that participation. We use that power to protect health and the environment and to create positive, lasting change in corporate behavior for the long-term benefit of humanity.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In 2015, we launched ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.fff, title: 'Fossil Free Funds' },
                'Fossil Free Funds'
              ),
              ' so that people could see if their retirement was funding climate change. In 2016, we followed up with ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.dff, title: 'Deforestation Free Funds' },
                'Deforestation Free Funds'
              ),
              '. We are committed to transparency, corporate accountability, and empowering individuals to take control of their investments.'
            ),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '9' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '9. Where do you get your data?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'The financial data powering Tobacco Free Funds is sourced from Morningstar. Morningstar, Inc. is a leading provider of independent investment research in North America, Europe, Australia, and Asia. The company works directly with investors and financial advisors to create products that help them meet their personal financial goals, providing the most reliable and pertinent information available on investment vehicles across industries. Morningstar provides data on approximately 500,000 investment offerings, including U.S. stocks and mutual funds, along with real-time global market data on more than 14 million equities and indexes, as well as foreign exchange and Treasury markets.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Tobacco companies are identified using Morningstar industry classifications. Under Morningstar\u2019s Global Equity Classification Structure, each equity is mapped into one of 148 industries that most accurately reflects the underlying business of that company. This mapping is based on publicly available information about each company using annual reports, Form 10-Ks, and Morningstar Equity Analyst input as its primary source. Other secondary sources of information may include company websites, sell-side research (if available), and trade publications.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { to: 'http://corporate.morningstar.com/EquityClassifications/', xstrong: true, title: 'Morningstar industry classifications' },
                'See the full list of Morningstar industry classifications'
              )
            ),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: '10' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            '10. Where can I learn more?'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'div',
              { styleName: 'answer-subtitle' },
              'Media'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'http://tobaccocontrol.bmj.com/content/11/suppl_1/i81.full', xstrong: true, title: 'How the Tobacco Industry Built its Relationship with Hollywood' },
                  'How the Tobacco Industry Built its Relationship with Hollywood'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2596576/', xstrong: true, title: 'Fiscal Versus Social Responsibility: How Philip Morris Shaped the Public Funds Divestment Debate' },
                  'Fiscal Versus Social Responsibility: How Philip Morris Shaped the Public Funds Divestment Debate'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'http://www.encognitive.com/node/7270', xstrong: true, title: 'Tobacco Divestment: A New Front in the Tobacco Wars' },
                  'Tobacco Divestment: A New Front in the Tobacco Wars'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-subtitle' },
              'Resources'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'http://www.asyousow.org/our-work/environmental-health/smoke-free-movies/', xstrong: true, title: 'As You Sow: Smoke Free Movies Initiative' },
                  'As You Sow\u2019s Smoke-Free Movies Initiative'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'http://smokefreemovies.ca/', xstrong: true, title: 'The Ontario Coalition for Smoke-Free Movies' },
                  'The Ontario Coalition for Smoke-Free Movies'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                'World Health Organization Reports',
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      { to: 'http://www.who.int/fctc/guidelines/adopted/article_13/en/', xstrong: true, title: 'WHO: Guidelines on tobacco advertising, promotion and sponsorship ' },
                      'Guidelines on tobacco advertising, promotion and sponsorship'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      { to: 'http://www.who.int/tobacco/publications/marketing/smoke-free-movies-third-edition/en/', xstrong: true, title: 'WHO: Reports' },
                      'Reports'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'https://smokefreemovies.ucsf.edu/', xstrong: true, title: 'UCSF Smokefree Movies project' },
                  'UCSF Smokefree Movies project'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'https://www.cdc.gov/tobacco/data_statistics/fact_sheets/youth_data/movies/', xstrong: true, title: 'CDC Fact Sheet for Smoking in the Movies' },
                  'CDC Fact Sheet for Smoking in the Movies'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'http://www.tobaccofreeportfolios.org/', xstrong: true, title: 'Tobacco Free Portfolios' },
                  'Tobacco Free Portfolios'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { to: 'http://truthinitiative.org/', xstrong: true, title: 'Truth Initiative' },
                  'Truth Initiative'
                )
              )
            ),
            _this.renderTop()
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: 'contact' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Have a question that isn\'t addressed here? Get in touch with As You Sow'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                {
                  xstrong: true,
                  styleName: 'contact',
                  to: _config2.default.links.contact,
                  title: 'Contact As You Sow'
                },
                'Contact',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _this.renderTop()
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(FAQ, [{
    key: 'render',
    value: function render() {
      var faqTitle = 'Frequently asked questions';

      // 
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _container2.default.helmet(faqTitle),
          _react2.default.createElement(
            'div',
            { styleName: 'faq' },
            _react2.default.createElement(
              'div',
              { styleName: 'faq-inner' },
              _react2.default.createElement(
                'h1',
                { styleName: 'title' },
                faqTitle
              ),
              this.renderQuestions(),
              this.renderAnswers()
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(_components.DonateBanner, null),
        _react2.default.createElement(
          'div',
          { styleName: 'banner-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return FAQ;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = FAQ;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FAQ/FAQ.js
// module id = 1288
// module chunks = 0